// Denetim izi enum → Türkçe etiket eşlemeleri.
// entityType değerleri backend AuditEntityTypes.java sabitleriyle birebir;
// yeni bir tip eklenirse burada karşılığı yoksa ham kod görünür (bilinçli:
// yanlış tahmin yerine ham değer, eksik map buradan tamamlanır).
export const ENTITY_TYPE_LABELS = {
    USER: "Kullanıcı",
    COMPANY: "Firma",
    ACCOUNT: "Cari",
    ACCOUNT_MOVEMENT: "Cari Hareketi",
    PAYMENT: "Ödeme",
    PAYMENT_REFUND: "Ödeme İadesi",
    PAYMENT_LINK: "Ödeme Linki",
    VIRTUAL_POS_SETTINGS: "Sanal POS Ayarları",
    POS_EARNING_CONFIG: "POS Kazanç Ayarı",
    POS_VALOR_CONFIG: "POS Valör Ayarı",
    MAIL_SETTINGS: "E-posta Ayarları",
    SMS_SETTINGS: "SMS Ayarları",
    ACCOUNTING_SETTINGS: "Muhasebe Ayarları",
    REFERRAL: "Davet",
    REFERRAL_SETTINGS: "Referans Programı Ayarları",
    PLAN_TRIAL: "Paket Denemesi",
    ACTIVE_POS: "Aktif POS",
    INSTALLMENT_GROUP: "Taksit Grubu",
    SUBSCRIPTION: "Abonelik",
    SUBSCRIPTION_PLAN: "Paket Tanımı",
    PRICE_OVERRIDE: "Firmaya Özel Fiyat",
    COUPON: "Kupon",
    ADDON_MODULE: "Ek Modül Tanımı",
    COMPANY_ADDON: "Firma Ek Modülü",
    FEATURE_TRIAL: "Özellik Denemesi",
    SCHEDULED_REPORT: "Zamanlanmış Rapor",
    TICKET: "Destek Talebi",
    REGISTRATION: "Kayıt Başvurusu",
    ACCOUNTING_MAPPING: "Muhasebe Cari Eşleştirmesi",
    DATA_EXPORT: "Veri Dışa Aktarımı",
    RECONCILIATION: "Mutabakat",
};

export const entityTypeLabel = (type) => ENTITY_TYPE_LABELS[type] || type;
